export const COLORS = {
  red: "#E70404",
  darkRed: "#990202",
  orange: "#FB5C03",
  darkOrange: "#953702",
  blue: "#455FE8",
  darkBlue: "#001EBD",
  lightBlue: "#119AF4",
  darkLightBlue: "#024D80",
  black: "#000000",
};
